export default __webpack_public_path__ + "static/media/bci-2.46920881.svg";